// extracted by mini-css-extract-plugin
module.exports =  {"horizontal-group":"_734d14f77d--horizontal-group--pefCW","vertical-group":"_734d14f77d--vertical-group--zi1Aj"};